import React from 'react';
import { IProps } from './type';

const MenuIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 7H19"
        stroke={strokeColor ? strokeColor : "#212121"}
        strokeLinecap="round" />
      <path
        d="M5 12H19"
        stroke={strokeColor ? strokeColor : "#212121"}
        strokeLinecap="round" />
      <path
        d="M5 17H19"
        stroke={strokeColor ? strokeColor : "#212121"}
        strokeLinecap="round" />
    </svg>
  )
};

export default MenuIcon;
